import React, { createContext, useContext, useMemo, useState } from 'react';

/** sm+ collapsed rail width (px) */
export const SIDEBAR_RAIL_COLLAPSED_PX = 72;
/** sm+ expanded width (px) */
export const SIDEBAR_RAIL_EXPANDED_PX = 250;
/** xs sidebar width (px) */
export const SIDEBAR_XS_WIDTH_PX = 200;

const SidebarRailContext = createContext(null);

export const SidebarRailProvider = ({ children }) => {
  const [railExpanded, setRailExpanded] = useState(true);
  const value = useMemo(() => ({ railExpanded, setRailExpanded }), [railExpanded]);
  return <SidebarRailContext.Provider value={value}>{children}</SidebarRailContext.Provider>;
};

export const useSidebarRail = () => {
  const ctx = useContext(SidebarRailContext);
  if (!ctx) {
    throw new Error('useSidebarRail must be used within SidebarRailProvider');
  }
  return ctx;
};
